export default __webpack_public_path__ + "images/b2282fb7165cfe253b4f669ab2f1ad70.jpg";